import { GET_OFFLINE_COUPONS, USE_OFFLINE_COUPONS, SET_SELECTED_COUPON, GET_OFFLINE_COUPONS_SUCCESS, GET_OFFLINE_COUPONS_ERROR, USE_OFFLINE_COUPONS_ERROR, SHOW_OFFLINE_COUPON_CONTENT, } from '../../constants';
export function getOfflineCouponsAction() {
    return {
        type: GET_OFFLINE_COUPONS,
    };
}
export function getOfflineCouponsSuccess() {
    return {
        type: GET_OFFLINE_COUPONS_SUCCESS,
    };
}
export function getOfflineCouponsError() {
    return {
        type: GET_OFFLINE_COUPONS_ERROR,
    };
}
export function setSelectedCoupon(couponCode) {
    return {
        type: SET_SELECTED_COUPON,
        selectedCouponId: couponCode,
    };
}
export function useOfflineCoupon(payload) {
    return {
        type: USE_OFFLINE_COUPONS,
        payload,
    };
}
export function useOfflineCouponsError() {
    return {
        type: USE_OFFLINE_COUPONS_ERROR,
    };
}
export function toggleOfflineCouponTab(isOfflineContent) {
    return {
        type: SHOW_OFFLINE_COUPON_CONTENT,
        showOfflineContent: isOfflineContent,
    };
}
